export default __webpack_public_path__ + "media/images/mailer-new/welcome/feature_control-c2b9111d0727186f2fab45eee8f82146.png";